import React, { useContext } from 'react';
import { useModal } from "../../../contexts/ModalContext";
import Modal from "../../../Componentes/Utils/Modal";
import Overlay from "../../../Componentes/Overlay";

import GenericHeader from "../../../Componentes/GenericHeader";
import Filters from "../../../Componentes/Utils/Filters";
import Tabela from "../../../Componentes/Utils/Tabela";

import { useEffect, useState } from "react";
import axios from "axios";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";

import { FaTrashAlt } from "react-icons/fa";
import { MdModeEditOutline } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import { FaCheck } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import { IoSettingsSharp } from "react-icons/io5";

import styled from 'styled-components';
import ModalAddConteudo from './ModalAddConteudo';
import ModalDeleteConteudo from './ModalDeleteConteudo';
import ModalAddTreinamento from './ModalAddTreinamento';
import ModalDeleteTreinamento from './ModalDeleteTreinamento';
import ModalEditConfig from './ModalEditConfig';
import FilterContainer from '../../../Componentes/Utils/FilterContainer';
import { AuthContext } from '../../../Auth/AuthProvider';
import { VerifyPermission } from '../../../Funcoes/VerifyPermission';

const ContainerBotoes = styled.div`
    display: flex;
    justify-content: space-between;
    margin-right: 15px;
`

const BotaoAcao = styled.button`
    width: 25px;
    height: 25px;
    padding: 0;
    cursor: pointer;
    background-color: transparent;
    border: none;
`

const IconEdit = styled(MdModeEditOutline)`
    color: blue;
    width: 100%;
    height: 100%;
`

const IconAdd = styled(FiPlusCircle)`
    color: green;
    width: 100%;
    height: 100%;
`

const IconDelete = styled(FaTrashAlt)`
    color: red;
    width: 90%;
    height: 90%;
`

const IconSettings = styled(IoSettingsSharp)`
    color: gray;
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: .3s;
    &:hover{
        scale: 1.1;
    }
`

const LinhaAcao = styled.tr`
    color: black;
    background-color: rgba( 0, 128, 0, 0.6 ) !important;
    td{
        text-align: center !important;
    }
    transition: .3s;
    &:hover{
        background-color: rgba( 0, 128, 0, 0.9 ) !important;
    }
`

const LinhaCentralizada = styled.td`
    text-align: center !important;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ContainerIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin: auto;
`

const IconCheck = styled(FaCheck)`
    color: green;
    width: 90%;
    height: 90%;
`

const IconClose = styled(MdClose)`
    color: red;
    width: 100%;
    height: 100%;
`

const ContainerEdit = styled.div`
    width: 70px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin: auto;
`

const ConteudoCorpo = ({ atualizar }) => {

    const { user } = useContext(AuthContext);

    const { openModal, closeModal, isModalOpen } = useModal();

    const [modalData, setModalData] = useState({
        modo: null,
        item: null,
        parentId: null
    })

    const [deleteId, setDeleteId] = useState(null);

    const [dados, setDados] = useState([]);
    const [loading, setLoading] = useState(true)

    const [loadingConteudo, setLoadingConteudo] = useState(false);
    const [conteudoTreinamento, setConteudoTreinamento] = useState([])

    const [itemSelecionado, setItemSelecionado] = useState(null);

    useEffect(() => {

        fetchData();

    }, [])

    useEffect(() => {

        fetchData();

    }, [atualizar]);

    const fetchData = async () => {

        setLoading(true)

        try {

            const { data } = await axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/Treinamentos/GetCatalogo/", { withCredentials: true })
            console.log(data)

            setDados(data)

        } catch (e) {

            console.log(e)

        } finally {

            setLoading(false)

        }

    }

    const [treinamentoId, setTreinamentoId] = useState(null);

    const getConteudo = async (id) => {

        setLoadingConteudo(true);

        try {

            const formData = new FormData();
            formData.append("id", id);

            const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/Treinamentos/GetConteudo/", formData, { withCredentials: true });
            console.log(data);
            setConteudoTreinamento(data);

        } catch (e) {

            console.log(e);

        } finally {

            setLoadingConteudo(false);

        }

    }

    const openInfo = async (id) => {

        openModal("tabelaConteudoProg");
        setLoadingConteudo(true)

        setTreinamentoId(id);

        await getConteudo(id);

    }

    const closeInfo = () => {

        setConteudoTreinamento([])
        setTreinamentoId(null);
        closeModal()

    }

    const editarTreinamento = (e, item) => {

        e.stopPropagation();

        if (VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) === false) {
            alert("Você não tem permissão para editar treinamentos no catálogo.");
            return;
        }

        openModal("modalAddTreinamento");
        setItemSelecionado(item);

    }

    const apagarTreinamento = (e, item) => {

        e.stopPropagation();

        if (VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) === false) {
            alert("Você não tem permissão para deletar treinamentos do catálogo.");
            return;
        }

        openModal("modalDeleteTreinamento");
        setItemSelecionado(item);

    }

    const setSettings = (e, item) => {

        e.stopPropagation();

        if (VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) === false) {
            alert("Você não tem permissão para deletar treinamentos do catálogo.");
            return;
        }

        setItemSelecionado(item);
        openModal("modalEditSettings");

    }

    const handleSuccess = () => {

        fetchData();
        closeModal();
        setItemSelecionado(null);

    }

    const renderConteudo = (dados, nivel = 0) => {
        return dados.map((obj) => (
            <React.Fragment key={obj.id}>
                <tr style={{ color: "#000" }} >
                    <td style={{ paddingLeft: `${nivel * 10 + 10}px` }}>
                        {obj.numero} - {obj.conteudo}
                    </td>
                    <td style={{ width: '180px' }}>
                        {
                            VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                <ContainerBotoes>
                                    <BotaoAcao>
                                        <IconEdit onClick={() => abrirModalConteudo({ modo: "edit", item: obj, parentId: obj.id_pai })} />
                                    </BotaoAcao>
                                    <BotaoAcao>
                                        <IconAdd onClick={() => abrirModalConteudo({ modo: "add", parentId: obj.identifier })} />
                                    </BotaoAcao>
                                    <BotaoAcao>
                                        <IconDelete onClick={() => abrirModalDelete(obj.id)} />
                                    </BotaoAcao>
                                </ContainerBotoes>
                            )
                        }
                    </td>
                </tr>
                {obj.filhos && obj.filhos.length > 0 && renderConteudo(obj.filhos, nivel + 1)}
            </React.Fragment>
        ));
    };

    const abrirModalConteudo = ({ modo = "add", item = null, parentId = null }) => {
        setModalData({ modo, item, parentId });
        openModal("modalConteudo");
    };

    const abrirModalDelete = (id) => {

        setDeleteId(id);
        openModal("modalDeleteConteudo");

    }

    const closeModalDelete = () => {

        setDeleteId(null);
        closeModal();

    }

    const [filterTreinamento, setFilterTreinamento] = useState("");

    return (
        <>
            <GenericHeader>
                <Filters columns={1} >
                    <FilterContainer
                        type="text"
                        placeholder="TREINAMENTO..."
                        changeFunc={(valor) => { setFilterTreinamento(valor) }}
                        valor={filterTreinamento}
                    />
                </Filters>
            </GenericHeader>
            <Tabela loading={loading} >
                <thead>
                    <tr>
                        <th>TREINAMENTO</th>
                        <th>CONTEÚDO</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dados
                            .filter(treinamento => treinamento.treinamento.toLowerCase().includes(filterTreinamento.toLowerCase()))
                            .map((treinamento) => (
                                <tr key={treinamento.id} onClick={() => openInfo(treinamento.identifier)} >
                                    <td>{treinamento.treinamento}</td>
                                    <LinhaCentralizada>
                                        <ContainerIcon>
                                            {treinamento.quantidade > 0 ? (<IconCheck />) : (<IconClose />)}
                                        </ContainerIcon>
                                    </LinhaCentralizada>
                                    <td>{
                                        VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                            <IconSettings onClick={(e) => setSettings(e, treinamento)} />
                                        )
                                    }</td>
                                    <td>
                                        {
                                            VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                                <ContainerEdit>
                                                    <IconEdit onClick={(e) => editarTreinamento(e, treinamento)} />
                                                    <IconDelete onClick={(e) => apagarTreinamento(e, treinamento)} />
                                                </ContainerEdit>
                                            )
                                        }
                                    </td>
                                </tr>
                            ))
                    }
                </tbody>
            </Tabela>
            {
                isModalOpen("tabelaConteudoProg") && (
                    <Overlay state={true} >
                        <Modal close={closeInfo} size="xl" header={true} >
                            {
                                loadingConteudo ? (
                                    <SmallLoading />
                                ) : (
                                    <>
                                        <Tabela>
                                            <thead>
                                                <tr>
                                                    <th colSpan={2} >CONTEÚDO DO TREINAMENTO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderConteudo(conteudoTreinamento)}
                                                {
                                                    VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                                        <LinhaAcao>
                                                            <td colSpan={2} onClick={() => abrirModalConteudo({ modo: "add" })} >ADICIONAR NOVO ITEM </td>
                                                        </LinhaAcao>
                                                    )
                                                }
                                            </tbody>
                                        </Tabela>
                                    </>
                                )
                            }
                        </Modal>
                    </Overlay>
                )
            }
            {
                isModalOpen("modalConteudo") && (
                    <ModalAddConteudo
                        modo={modalData.modo}
                        item={modalData.item}
                        parentId={modalData.parentId}
                        onClose={closeModal}
                        onSuccess={() => getConteudo(treinamentoId)}
                        treinamentoId={treinamentoId}
                    />
                )
            }
            {
                isModalOpen("modalDeleteConteudo") && (
                    <ModalDeleteConteudo
                        id={deleteId}
                        onClose={closeModalDelete}
                        onSuccess={() => getConteudo(treinamentoId)}
                    />
                )
            }
            {
                isModalOpen("modalAddTreinamento") && (
                    <ModalAddTreinamento
                        modo="edit"
                        item={itemSelecionado}
                        onSuccess={handleSuccess}
                    />
                )
            }
            {
                isModalOpen("modalDeleteTreinamento") && (
                    <ModalDeleteTreinamento
                        item={itemSelecionado}
                        onSuccess={handleSuccess}
                    />
                )
            }
            {
                isModalOpen("modalEditSettings") && (
                    <ModalEditConfig
                        item={itemSelecionado}
                        onSuccess={handleSuccess}
                    />
                )
            }
        </>
    )

}

export default ConteudoCorpo;